import { format } from 'date-fns-tz';

import { getLinkTextCellColumn } from 'src/app/components/lib/table';

import type { GridColDef } from '@mui/x-data-grid-pro';

export function useEmailColumns() {
  const baseColumns: GridColDef[] = [
    getLinkTextCellColumn({
      field: 'name',
      headerName: 'Name',
      valueGetter: (params) => {
        const { row } = params;
        return `${String(row.FirstName)} ${String(row.LastName)}`;
      },
    }),
    { field: 'Email', headerName: 'Email' },
    {
      field: 'ProcessedUtc',
      headerName: 'Processed',
      valueGetter: ({ row }) =>
        row.ProcessedUtc ? format(new Date(`${String(row.ProcessedUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
    {
      field: 'DeliveredUtc',
      headerName: 'Delivered',
      valueGetter: ({ row }) =>
        row.DeliveredUtc ? format(new Date(`${String(row.DeliveredUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
    {
      field: 'OpenedUtc',
      headerName: 'Opened',
      valueGetter: ({ row }) =>
        row.OpenedUtc ? format(new Date(`${String(row.OpenedUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
    {
      field: 'ClickedUtc',
      headerName: 'Clicked',
      valueGetter: ({ row }) =>
        row.ClickedUtc ? format(new Date(`${String(row.ClickedUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
    {
      field: 'BouncedUtc',
      headerName: 'Bounced',
      valueGetter: ({ row }) =>
        row.BouncedUtc ? format(new Date(`${String(row.BouncedUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
    {
      field: 'DroppedUtc',
      headerName: 'Dropped',
      valueGetter: ({ row }) =>
        row.DroppedUtc ? format(new Date(`${String(row.DroppedUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
    {
      field: 'SpamReportedUtc',
      headerName: 'Spam Report',
      valueGetter: ({ row }) =>
        row.SpamReportedUtc ? format(new Date(`${String(row.SpamReportedUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
    {
      field: 'UnsubscribedUtc',
      headerName: 'Unsubscribed',
      valueGetter: ({ row }) =>
        row.UnsubscribedUtc ? format(new Date(`${String(row.UnsubscribedUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
    {
      field: 'DeferredUtc',
      headerName: 'Deferred',
      valueGetter: ({ row }) =>
        row.DeferredUtc ? format(new Date(`${String(row.DeferredUtc)}`), 'MM/dd/yyyy hh:mm a') : '--',
      sortable: false,
    },
  ];

  return baseColumns;
}
